import Address from '../AddressBuilder'
import HttpConfig from '../../request/HttpConfig'

const _path = {
  DIC_DATA: Address.sys('sys/dict/data'),
}

export default {

  config: HttpConfig.obtain().closeLoading().done(),

  listByType(type) {// 根据字典类型查询字典数据信息
    const _parameter = {
      dictType: type
    }
    return sHttp.postJson(_path.DIC_DATA + 'getListByDictType', _parameter, this.config)
  },

  page(_parameter) {// page
    return sHttp.postJson(_path.DIC_DATA + 'page', _parameter, this.config)
  },

  list(_parameter) {// list
    return sHttp.postJson(_path.DIC_DATA + 'list', _parameter, this.config)
  },

  add(_parameter) {// add
    return sHttp.postJson(_path.DIC_DATA + 'add', _parameter, this.config)
  },

  update(_parameter) {// update
    return sHttp.postJson(_path.DIC_DATA + 'update', _parameter, this.config)
  },

  detail(id) {// detail
    const _parameter = {id: id}
    return sHttp.postJson(_path.DIC_DATA + 'detail', _parameter, this.config)
  },

  deleteForce(id) {// deleteForce
    const _parameter = {id: id}
    return sHttp.postJson(_path.DIC_DATA + 'deleteForce', _parameter, this.config)
  },

}

